import clsx from 'clsx';
import { format } from 'date-fns';
import Image from 'next/image';
import React from 'react';

import Button from '@/components/Primitive/Button/Button';
import SmartLink from '@/components/Primitive/SmartLink';

interface IFeaturedPost {
  title: string;
  sell: string;
  thumbnail: string;
  href: string;
  publishedDate?: string;
  className?: string;
}

const FeaturedPost = ({
  title,
  sell,
  thumbnail,
  href,
  publishedDate,
  className,
}: IFeaturedPost) => {
  return (
    <div
      className={clsx(
        'flex w-full flex-col-reverse md:flex-row md:space-x-10',
        className
      )}
    >
      <div className="flex flex-col items-start justify-start space-y-4 md:max-w-[450px]">
        <SmartLink tabIndex={-1} to={href} className="space-y-2">
          <h3 className="text-2xl font-black uppercase text-cream md:text-3xl">
            {title}
          </h3>
          {publishedDate && (
            <time
              dateTime={publishedDate}
              className="text-sm uppercase text-cream"
            >
              {format(new Date(publishedDate), 'MMMM dd, yyyy')}
            </time>
          )}
          <p className="text-grayAlt-500">{sell}</p>
        </SmartLink>
        <Button className="self-end uppercase md:self-start" to={href}>
          Read more
        </Button>
      </div>

      <SmartLink
        tabIndex={-1}
        to={href}
        className="hover-scale block grow overflow-hidden rounded-md pb-4 md:basis-2/3 md:pb-0"
      >
        <Image
          src={thumbnail}
          alt={title}
          width={740}
          height={440}
          className="rounded-md object-cover"
        />
      </SmartLink>
    </div>
  );
};

export default FeaturedPost;
